import React, { useEffect } from "react";

// This page handles the popup callback for Google OAuth
// It extracts the session_id and sends it back to the parent window
const AuthCallbackPage = () => {
  useEffect(() => {
    // Get session_id from URL hash
    const hash = window.location.hash;
    const sessionIdMatch = hash.match(/session_id=([^&]+)/);
    
    if (sessionIdMatch) {
      const sessionId = sessionIdMatch[1];
      
      // Send message to parent window (opener)
      if (window.opener) {
        window.opener.postMessage({
          type: 'AUTH_SUCCESS',
          sessionId: sessionId
        }, window.location.origin);
      }
      
      // Close this popup after a brief moment
      setTimeout(() => {
        window.close();
      }, 500);
    } else {
      // No session_id found, close popup
      window.close();
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#030303] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-400 font-mono text-sm">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
